import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Импорт Firebase Storage

const firebaseConfig = {
    apiKey: "AIzaSyDrGpIpneoRCIrFtEhyiCUDfLM-Pvl02mY",
    authDomain: "spario-2d6d2.firebaseapp.com",
    databaseURL: "https://spario-2d6d2-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "spario-2d6d2",
    storageBucket: "spario-2d6d2.firebasestorage.app",
    messagingSenderId: "770240014851",
    appId: "1:770240014851:web:679af4c08d93ec4eb2fc36",
    measurementId: "G-MGHYGL0HFL"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const firestore = getFirestore(app);
const storage = getStorage(app); // Инициализация Firebase Storage

export { auth, database, firestore, storage };
